"use strict";

var _interopRequireDefault = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.teachingTime = teachingTime;
var _request = _interopRequireDefault(require("@/utils/request"));
// 本学期教学日历
function teachingTime(params) {
  return (0, _request.default)({
    url: '/skl/difficult/TeachingTime',
    method: 'get',
    params: params
  });
}